// removed by extract-text-webpack-plugin
module.exports = {"inactive-color":"users__inactive-color___3MX29","icon-color":"users__icon-color___zVC1A","btn-background-color":"users__btn-background-color___2o-2F","btn-group":"users__btn-group___1YkLS","btn-background-color-focus":"users__btn-background-color-focus___2C0QK"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Setup/Users/users.less
// module id = 1395
// module chunks = 3